export enum Direction {
    Top,
    Bottom,
    Right,
    Left
}
